import { AdminApiClient, createAdminApiClient } from "@shopify/admin-api-client";
import _ from "lodash";

import { ShopifyAdminConfig } from "./config";

export const ShopifyAdminClient = _.memoize(
  () =>
    ShopifyAdminConfig().useShopifyMockClient
      ? shopifyMockClient
      : createAdminApiClient({
          storeDomain: ShopifyAdminConfig().shopifyStoreDomain,
          apiVersion: "2025-07",
          accessToken: ShopifyAdminConfig().shopifyAdminApiToken,
        }),
  () => JSON.stringify(ShopifyAdminConfig()),
);

type ShopifyMockResponses = {
  [key: string | number | symbol]: any;
};

const shopifyMockResponses: ShopifyMockResponses = {};

const shopifyMockClient: AdminApiClient = {
  request: async (query, variables) => {
    const res = shopifyMockResponses[query];
    if (!res) throw new Error("Mock response not found");
    return res;
  },
  ...({} as any),
};
declare const shopifyRequest: AdminApiClient["request"];

type ShopifyRequestResponse<T extends string> = Awaited<ReturnType<typeof shopifyRequest<undefined, T>>>;

export const mockShopifyAdminResponse = <T extends string>(q: T, response: ShopifyRequestResponse<T>) => {
  shopifyMockResponses[q] = response;
};
